import baseApi from "../api/baseApi";

const certificateApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    verifyCertificate: builder.query({
      query: (certificateId) => ({
        url: `/certificate/verify/${certificateId}`,
        method: "GET",
      }),
    }),
    getCertificatePreview: builder.query({
      query: (enrollmentId) => ({
        url: `/certificate/preview/${enrollmentId}`,
        method: "GET",
      }),
      providesTags: ["Certificates"],
    }),
    generateCertificate: builder.mutation({
      query: (enrollmentId) => ({
        url: `/certificate/generate/${enrollmentId}`,
        method: "POST",
      }),
      invalidatesTags: ["Certificates"],
    }),
    getMyCertificates: builder.query({
      query: () => ({
        url: "/certificate/my",
        method: "GET",
      }),
      providesTags: ["Certificates"],
    }),
    getMyCertificateById: builder.query({
      query: (certificateId) => ({
        url: `/certificate/my/${certificateId}`,
        method: "GET",
      }),
      providesTags: ["Certificates"],
    }),
  }),
});

export const {
  useVerifyCertificateQuery,
  useLazyVerifyCertificateQuery,
  useGetCertificatePreviewQuery,
  useLazyGetCertificatePreviewQuery,
  useGenerateCertificateMutation,
  useGetMyCertificatesQuery,
  useGetMyCertificateByIdQuery,
} = certificateApi;

export default certificateApi;
